export enum Months {
    JANUARY = 0,
    FEBRUARY = 1,
    MARCH = 2,
    APRIL = 3,
    MAY = 4,
    JUNE = 5,
    JULY = 6,
    AUGUST = 7,
    SEPTEMBER = 8,
    OCTOBER = 9,
    NOVEMBER = 10,
    DECEMBER = 11
}

export declare type January = 'January'
export declare type February = 'February'
export declare type March = 'March'
export declare type April = 'April'
export declare type May = 'May'
export declare type June = 'June'
export declare type July = 'July'
export declare type August = 'August'
export declare type September = 'September'
export declare type October = 'October'
export declare type November = 'November'
export declare type December = 'December'

export declare type Month =
    | January
    | February
    | March
    | April
    | May
    | June
    | July
    | August
    | September
    | October
    | November
    | December

export const allMonths: Array<Month> = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
]
